module.exports = __webpack_public_path__ + "static/img/ga.auth.e2722e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ga.auth.png
// module id = 1304
// module chunks = 382